import Home from '@/components/Home'
import Layout from '@/components/Layout'
import AgregarModelo from '@/components/Modelos/AgregarModelo'
import Items from '@/components/Modelos/Items'
import Profile from '@/components/Modelos/Profile'
import listItems from '@/components/Modelos/Listas/ListItems'
import Alllist from '@/components/Modelos/Listas/Alllist'
import ApprovedList from '@/components/Modelos/Listas/ApprovedList'
import PendingList from '@/components/Modelos/Listas/PendingList'
import NewList from '@/components/Modelos/Listas/NewList'
import BlockList from '@/components/Modelos/Listas/BlockList'
import DeleteList from '@/components/Modelos/Listas/DeleteList'
import Categorias from '@/components/Tienda/Categorias'
import Productos from '@/components/Tienda/Productos'
import LayoutProducts from '@/components/Tienda/ProductLayout.vue'
import ProductProfile from '@/components/Tienda/ProductProfile'
import ItemsSolicitudes from '@/components/Solicitudes/Items'
import Documentos from '@/components/Solicitudes/Documentos'
import DeleteProducts from '@/components/Solicitudes/DeleteProducts'
import Picture from '@/components/Solicitudes/Picture'
import GastosMultas from '@/components/Modelos/GastosMultas'
import NotificacionesSolicitudes from '@/components/Modelos/NotificacionesSolicitudes'
import CreateNotification from '@/components/Notificaciones/CreateNotification'
import NotificationSent from '@/components/Notificaciones/NotificationSent'
import NotificationPending from '@/components/Notificaciones/NotificationPending'
import NotificationPause from '@/components/Notificaciones/NotificationPause'
import Inventory from '@/components/Tienda/Inventario'
import Multas from '@/components/Reportes/Multas'
import Consumos from '@/components/Reportes/Consumos'
import ItemsPlataformas from '@/components/Reportes/Plataformas/Items'
import Chaturbate from '@/components/Reportes/Plataformas/Chaturbate'
import Stripchat from '@/components/Reportes/Plataformas/Stripchat'
import BongaCams from '@/components/Reportes/Plataformas/BongaCams'
import CamSoda from '@/components/Reportes/Plataformas/CamSoda'
import SkyPrivate from '@/components/Reportes/Plataformas/SkyPrivate'
import AgregarPerfilAdministrativo from '@/components/AdminsProfiles/AddAdminProfile'
import ModelReports from '@/components/Modelos/Reports'
import ModelNomina from '@/components/Modelos/Nomina'
import AdminList from '@/components/AdminsProfiles/AdminList'
import StudioPlatforms from '@/components/Reportes/StudioPlatforms'
import ProfileAdmin from '@/components/Profile'
import Ingresos from '@/components/Reportes/Ingresos'
import Anticipos from '@/components/Reportes/Anticipos'
import AdminItems from '@/components/AdminsProfiles/AdminItems'
import AdminProfile from '@/components/AdminsProfiles/AdminProfile'
import AdminGastosMultas from '@/components/AdminsProfiles/AdminGastosMultas'
import AdminNotificacionesSolicitudes from '@/components/AdminsProfiles/AdminNotificacionesSolicitudes'

export default {
    path: '/',
    component: Layout,
    children: [
        {
            path: '',
            name: 'Nomina',
            component: Home
        },
        {
            path: 'agregar-modelo',
            name: 'Agregar-modelo',
            component: AgregarModelo
        },
        {
            path: 'agregar-perfil-administrativo',
            name: 'Agregar-modelo',
            component: AgregarPerfilAdministrativo
        },
        {
            path: 'personal-administrativo',
            name: 'Agregar-modelo',
            component: AdminList
        },
        {
            path: 'modelos-eliminadas',
            name: 'delete',
            component: DeleteList
        },
        {
            path: 'productos',
            name: 'productos',
            component: LayoutProducts,
            children: [
                {
                    path: ':product_name/profile',
                    name: 'product-profile',
                    component: ProductProfile
                },
                {
                    path: '',
                    name: 'productos',
                    component: Productos
                }
            ]
        },
        {
            path: 'solicitudes',
            name: 'solicitudes',
            component: ItemsSolicitudes,
            children: [
                {
                    path: 'documentos',
                    name: 'Documentos',
                    component: Documentos
                },
                {
                    path: 'productos',
                    name: 'ProductosDelete',
                    component: DeleteProducts
                },
                {
                    path: 'picture',
                    name: 'Picture',
                    component: Picture
                }
            ]
        },
        {
            path: 'plataformas',
            name: 'plataformas',
            component: ItemsPlataformas,
            children: [
                {
                    path: '',
                    name: 'estudio',
                    component: StudioPlatforms
                },
                {
                    path: 'chaturbate',
                    name: 'chaturbate',
                    component: Chaturbate
                },
                {
                    path: 'stripchat',
                    name: 'stripchat',
                    component: Stripchat
                },
                {
                    path: 'bongacams',
                    name: 'bongacams',
                    component: BongaCams
                },
                {
                    path: 'camsoda',
                    name: 'camsoda',
                    component: CamSoda
                },
                {
                    path: 'skyprivate',
                    name: 'skyprivate',
                    component: SkyPrivate
                }
            ]
        },
        {
            path: 'modelo/:model_id',
            name: 'items',
            component: Items,
            children: [
                {
                    path: 'profile',
                    name: 'profile',
                    component: Profile
                },
                {
                    path: 'gastos-multas',
                    name: 'gastos-multas',
                    component: GastosMultas
                },
                {
                    path: 'notificaciones-solicitudes',
                    name: 'notificaciones-solicitudes',
                    component: NotificacionesSolicitudes
                },
                {
                    path: 'reportes',
                    name: 'reportes',
                    component: ModelReports
                },
                {
                    path: 'nomina',
                    name: 'nomina',
                    component: ModelNomina
                }
            ]
        },
        {
            path: 'admin/:admin_id',
            name: 'items',
            component: AdminItems,
            children: [
                {
                    path: 'profile-admin',
                    name: 'profile-admin',
                    component: AdminProfile
                },
                {
                    path: 'gastos-multas-admin',
                    name: 'gastos-multas-admin',
                    component: AdminGastosMultas
                },
                {
                    path: 'notificaciones-solicitudes-admin',
                    name: 'notificaciones-solicitudes-admin',
                    component: AdminNotificacionesSolicitudes
                }
            ]
        },
        {
            path: 'listas',
            name: 'lista',
            component: listItems,
            children: [
                {
                    path: '',
                    name: 'lista',
                    component: Alllist
                },
                {
                    path: 'aprobadas',
                    name: 'aprobadas',
                    component: ApprovedList
                },
                {
                    path: 'pendientes',
                    name: 'pendientes',
                    component: PendingList
                },
                {
                    path: 'nuevas',
                    name: 'nuevas',
                    component: NewList
                },
                {
                    path: 'bloqueadas',
                    name: 'bloqueadas',
                    component: BlockList
                }
            ]
        },
        {
            path: 'categorias',
            name: 'categorias',
            component: Categorias
        },
        {
            path: 'inventarios',
            name: 'inventarios',
            component: Inventory
        },
        {
            path: 'crear-notificacion',
            name: 'creat-notificacion',
            component: CreateNotification
        },
        {
            path: 'notificaciones-enviadas',
            name: 'notificaciones-enviadas',
            component: NotificationSent,
            props: true
        },
        {
            path: 'notificaciones-pendientes',
            name: 'notificaciones-pendientes',
            component: NotificationPending,
            props: true
        },
        {
            path: 'notificaciones-pausadas',
            name: 'notificaciones-pausadas',
            component: NotificationPause,
            props: true
        },
        {
            path: 'egresos',
            name: 'multas',
            component: Multas
        },
        {
            path: 'ingresos',
            name: 'ingresos',
            component: Ingresos
        },
        {
            path: 'anticipos',
            name: 'anticipos',
            component: Anticipos
        },
        {
            path: 'consumos',
            name: 'consumos',
            component: Consumos
        },
        {
            path: 'perfil',
            name: 'profile',
            component: ProfileAdmin
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/admin.js